// extracted by mini-css-extract-plugin
export default {"root":"ProductOrGroupsLabel_root__7N9fq"};